export default function initializeAllCollapses() {
    document.querySelectorAll( '[data-id-collapse]' ).forEach( function( block ) {
        new Collapse(block);
    } );
}

class Collapse {
    constructor(block) {
        this.block = block;
        this.init();
    }
    init() {


        const mapContainer = document.querySelector('.ineraktive_map__bg');
        const regions = document.querySelectorAll('.ineraktive_map__region');
        const contentItems = document.querySelectorAll('.ineraktive_map__content__item');
        const baseContent = document.getElementById('content_base');

        let lastClickedRegionId = null; // Зберігає ID останнього клікнутого регіону

// Функція для приховування всіх описів
        function hideAllContent() {
            contentItems.forEach(item => item.style.display = 'none');
            baseContent.style.display = 'none'; // Ховаємо базовий опис
        }

// Функція для відображення опису регіону
        function showRegionContent(regionId) {
            hideAllContent();
            const contentToShow = document.getElementById('content_' + regionId);
            if (contentToShow) {
                contentToShow.style.display = 'block';
            }
        }

        // Функція для встановлення фону карти
        function setMapBackground(regionId) {
            if (regionId === "gdansk") {
                mapContainer.style.backgroundPosition = "0 -100%";
            } else if (regionId === "lublin") {
                mapContainer.style.backgroundPosition = "0 -40%";
            } else if (regionId === "warszawa") {
                mapContainer.style.backgroundPosition = "0 -60%";
            } else if (regionId === "poznan-wroclaw") {
                mapContainer.style.backgroundPosition = "0 -80%";
            } else if (regionId === "krakow") {
                mapContainer.style.backgroundPosition = "0 -20%";
            } else {
                mapContainer.style.backgroundPosition = "0 0"; // Початковий фон
            }
        }

// Додаємо події для кліку
        regions.forEach(region => {
            region.addEventListener('click', () => {
                const regionId = region.id;
                lastClickedRegionId = regionId; // Зберігаємо ID клікнутого регіону
                showRegionContent(regionId);
                setMapBackground(regionId);
            });

            // Додаємо hover ефект
            region.addEventListener('mouseenter', () => {
                const regionId = region.id;
                setMapBackground(regionId); // Тимчасово змінюємо фон для hover
            });

            region.addEventListener('mouseleave', () => {
                // Повертаємо фон до клікнутого регіону або до початкового, якщо кліку не було
                setMapBackground(lastClickedRegionId);
            });
        });


        // const map_element = this.block.querySelectorAll('.ineraktive_map_marker');
        // map_element.forEach(item => {
        //     const num = item.getAttribute('data-id');
        //     const needblock= document.getElementById('ineraktive_map-' + num);
        //     item.addEventListener('mouseover', () => {
        //         needblock.style.display = 'block';
        //     });
        //     item.addEventListener('mouseout', () => {
        //       //  setTimeout(() => {
        //             needblock.style.display = 'none';
        //        // }, 50);
        //     });
        // });





        const accordionItems = this.block.querySelectorAll('.block-collapse__accordion__item');
        accordionItems.forEach(item => {
            const header = item.querySelector('.block-collapse__accordion__header');
            const content = item.querySelector('.block-collapse__accordion__content');
            header.addEventListener('click', () => {
                item.classList.toggle('active');
            });
        });

        // Sprawdzamy, czy w URL jest fragment '#buy' i jeśli tak, otwieramy drugi element
        if (window.location.hash === "#buy" && accordionItems.length > 1) {
            // Usuwamy klasę 'active' ze wszystkich elementów
            // accordionItems.forEach(item => {
            //     item.classList.remove("active");
            // });

            // Dodajemy klasę 'active' do drugiego elementu (indeks 1)
            const secondAccordionItem = accordionItems[1];
            secondAccordionItem.classList.add("active");

            // Obliczamy pozycję drugiego elementu i przesuwamy stronę o 100px
            const elementPosition = secondAccordionItem.getBoundingClientRect().top + window.pageYOffset - 160;
            window.scrollTo({ top: elementPosition, behavior: "smooth" });
        }


    }
}